import { brandColor } from '@/styles/constant'
import Step from '@mui/material/Step'
import StepConnector from '@mui/material/StepConnector'
import StepLabel from '@mui/material/StepLabel'
import OriginalStepper from '@mui/material/Stepper'
import { ComponentProps } from 'react'

const ICON_SIZE = 40

interface Props extends ComponentProps<typeof OriginalStepper> {
  items: string[]
}

export const Stepper = ({ items, ...rest }: Props) => {
  return (
    <OriginalStepper
      connector={<StepConnector sx={{ top: ICON_SIZE / 2 }} />}
      activeStep={0}
      alternativeLabel
      {...rest}
    >
      {items.map((item) => (
        <Step key={item}>
          <StepLabel
            StepIconProps={{
              sx: {
                height: ICON_SIZE,
                width: ICON_SIZE,
                '&.Mui-active': {
                  color: brandColor,
                },
                '&.Mui-completed': {
                  color: brandColor,
                },
              },
            }}
          >
            {item}
          </StepLabel>
        </Step>
      ))}
    </OriginalStepper>
  )
}
